import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1bf39195 = () => interopDefault(import('../../../pages/404-error/index.vue' /* webpackChunkName: "pages/404-error/index" */))
const _2ca16643 = () => interopDefault(import('../../../pages/app/index.vue' /* webpackChunkName: "pages/app/index" */))
const _63a74dc2 = () => interopDefault(import('../../../pages/builder-data-reports/index.vue' /* webpackChunkName: "pages/builder-data-reports/index" */))
const _04b87f59 = () => interopDefault(import('../../../pages/buy-sell-your-home/index.vue' /* webpackChunkName: "pages/buy-sell-your-home/index" */))
const _6965fdd4 = () => interopDefault(import('../../../pages/buy-your-home/index.vue' /* webpackChunkName: "pages/buy-your-home/index" */))
const _b475721c = () => interopDefault(import('../../../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _4b75d9bb = () => interopDefault(import('../../../pages/commissions-calculator/index.vue' /* webpackChunkName: "pages/commissions-calculator/index" */))
const _4c3d41fb = () => interopDefault(import('../../../pages/comparables/index.vue' /* webpackChunkName: "pages/comparables/index" */))
const _13fd3bfc = () => interopDefault(import('../../../pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _12a6ee10 = () => interopDefault(import('../../../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _1fa91144 = () => interopDefault(import('../../../pages/favourites/index.vue' /* webpackChunkName: "pages/favourites/index" */))
const _5569f2dd = () => interopDefault(import('../../../pages/homeowner-dashboard/index.vue' /* webpackChunkName: "pages/homeowner-dashboard/index" */))
const _61c3e750 = () => interopDefault(import('../../../pages/list-home/index.vue' /* webpackChunkName: "pages/list-home/index" */))
const _790043c0 = () => interopDefault(import('../../../pages/listing-management/index.vue' /* webpackChunkName: "pages/listing-management/index" */))
const _72946bcb = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _dd00b186 = () => interopDefault(import('../../../pages/market-data/index.vue' /* webpackChunkName: "pages/market-data/index" */))
const _9be4d900 = () => interopDefault(import('../../../pages/messages/index.vue' /* webpackChunkName: "pages/messages/index" */))
const _72944d0c = () => interopDefault(import('../../../pages/my-abode-overview/index.vue' /* webpackChunkName: "pages/my-abode-overview/index" */))
const _f566685c = () => interopDefault(import('../../../pages/my-listings/index.vue' /* webpackChunkName: "pages/my-listings/index" */))
const _28522fee = () => interopDefault(import('../../../pages/offer-management-buyer/index.vue' /* webpackChunkName: "pages/offer-management-buyer/index" */))
const _5f85f4fa = () => interopDefault(import('../../../pages/offer-management-seller/index.vue' /* webpackChunkName: "pages/offer-management-seller/index" */))
const _29f4576a = () => interopDefault(import('../../../pages/offers/index.vue' /* webpackChunkName: "pages/offers/index" */))
const _7aa4c450 = () => interopDefault(import('../../../pages/photo-booking-confirmation/index.vue' /* webpackChunkName: "pages/photo-booking-confirmation/index" */))
const _c37d812c = () => interopDefault(import('../../../pages/privacy/index.vue' /* webpackChunkName: "pages/privacy/index" */))
const _6fb655de = () => interopDefault(import('../../../pages/pro-edit/index.vue' /* webpackChunkName: "pages/pro-edit/index" */))
const _4bf1af66 = () => interopDefault(import('../../../pages/pro-marketplace/index.vue' /* webpackChunkName: "pages/pro-marketplace/index" */))
const _76db1488 = () => interopDefault(import('../../../pages/pro-search/index.vue' /* webpackChunkName: "pages/pro-search/index" */))
const _58895c21 = () => interopDefault(import('../../../pages/request-sticker/index.vue' /* webpackChunkName: "pages/request-sticker/index" */))
const _1cf031c8 = () => interopDefault(import('../../../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _af56f31c = () => interopDefault(import('../../../pages/sell-your-home/index.vue' /* webpackChunkName: "pages/sell-your-home/index" */))
const _1bbf668c = () => interopDefault(import('../../../pages/signup/index.vue' /* webpackChunkName: "pages/signup/index" */))
const _c287ad36 = () => interopDefault(import('../../../pages/sold-data/index.vue' /* webpackChunkName: "pages/sold-data/index" */))
const _24edceb9 = () => interopDefault(import('../../../pages/terms-of-service/index.vue' /* webpackChunkName: "pages/terms-of-service/index" */))
const _73728faa = () => interopDefault(import('../../../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _62ccd2fc = () => interopDefault(import('../../../pages/whoweare/index.vue' /* webpackChunkName: "pages/whoweare/index" */))
const _32ecb9e7 = () => interopDefault(import('../../../pages/why-bode/index.vue' /* webpackChunkName: "pages/why-bode/index" */))
const _fb1ddb28 = () => interopDefault(import('../../../pages/admin/builder-report-management/index.vue' /* webpackChunkName: "pages/admin/builder-report-management/index" */))
const _378ce177 = () => interopDefault(import('../../../pages/admin/conversation/index.vue' /* webpackChunkName: "pages/admin/conversation/index" */))
const _ffdc90f0 = () => interopDefault(import('../../../pages/admin/offer-management/index.vue' /* webpackChunkName: "pages/admin/offer-management/index" */))
const _c8ac1dfc = () => interopDefault(import('../../../pages/admin/showings/index.vue' /* webpackChunkName: "pages/admin/showings/index" */))
const _184e52d2 = () => interopDefault(import('../../../pages/listings/review.vue' /* webpackChunkName: "pages/listings/review" */))
const _d869df1e = () => interopDefault(import('../../../pages/login/idp/index.vue' /* webpackChunkName: "pages/login/idp/index" */))
const _52baea4b = () => interopDefault(import('../../../pages/login/reset/index.vue' /* webpackChunkName: "pages/login/reset/index" */))
const _6a6998e8 = () => interopDefault(import('../../../pages/offers/submit-success/index.vue' /* webpackChunkName: "pages/offers/submit-success/index" */))
const _c7d80fbc = () => interopDefault(import('../../../pages/offers/summary/index.vue' /* webpackChunkName: "pages/offers/summary/index" */))
const _b7fa9e10 = () => interopDefault(import('../../../pages/pro-edit/profile/index.vue' /* webpackChunkName: "pages/pro-edit/profile/index" */))
const _07c80f04 = () => interopDefault(import('../../../pages/pro-edit/service/index.vue' /* webpackChunkName: "pages/pro-edit/service/index" */))
const _ecd0bd78 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/index" */))
const _45ac6647 = () => interopDefault(import('../../../pages/pro-marketplace/pro-login/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-login/index" */))
const _ff888c38 = () => interopDefault(import('../../../pages/pro-marketplace/pro-portal/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-portal/index" */))
const _13899496 = () => interopDefault(import('../../../pages/pro-marketplace/service-request/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/index" */))
const _45468f18 = () => interopDefault(import('../../../pages/pro-marketplace/service-requests/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-requests/index" */))
const _c2a1132c = () => interopDefault(import('../../../pages/search/saved-search-list/index.vue' /* webpackChunkName: "pages/search/saved-search-list/index" */))
const _1b05ac82 = () => interopDefault(import('../../../pages/signup/additional-information/index.vue' /* webpackChunkName: "pages/signup/additional-information/index" */))
const _029d5ffd = () => interopDefault(import('../../../pages/signup/confirm/index.vue' /* webpackChunkName: "pages/signup/confirm/index" */))
const _6d16e032 = () => interopDefault(import('../../../pages/admin/listings/import/index.vue' /* webpackChunkName: "pages/admin/listings/import/index" */))
const _1e4a380b = () => interopDefault(import('../../../pages/admin/listings/update/index.vue' /* webpackChunkName: "pages/admin/listings/update/index" */))
const _8b2e09c8 = () => interopDefault(import('../../../pages/ds/callback/listing/index.vue' /* webpackChunkName: "pages/ds/callback/listing/index" */))
const _2c8be834 = () => interopDefault(import('../../../pages/ds/callback/offer/index.vue' /* webpackChunkName: "pages/ds/callback/offer/index" */))
const _e94c0a80 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index" */))
const _145b7052 = () => interopDefault(import('../../../pages/pro-marketplace/service-request/photography-measurements/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/photography-measurements/index" */))
const _69bf4f1f = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index" */))
const _602033d2 = () => interopDefault(import('../../../pages/pro-marketplace/profile/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/profile/_id/index" */))
const _aacf97ac = () => interopDefault(import('../../../pages/pro-marketplace/view-request/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/view-request/_id/index" */))
const _453c84e6 = () => interopDefault(import('../../../pages/buyer-checklist/_page/index.vue' /* webpackChunkName: "pages/buyer-checklist/_page/index" */))
const _69e9781c = () => interopDefault(import('../../../pages/how-it-works/_id/index.vue' /* webpackChunkName: "pages/how-it-works/_id/index" */))
const _651c61dc = () => interopDefault(import('../../../pages/listing-editing/_id/index.vue' /* webpackChunkName: "pages/listing-editing/_id/index" */))
const _0ed14a4e = () => interopDefault(import('../../../pages/listings/_id/index.vue' /* webpackChunkName: "pages/listings/_id/index" */))
const _2f43fb3a = () => interopDefault(import('../../../pages/pro/_id/index.vue' /* webpackChunkName: "pages/pro/_id/index" */))
const _2b84c82b = () => interopDefault(import('../../../pages/seller-checklist/_page/index.vue' /* webpackChunkName: "pages/seller-checklist/_page/index" */))
const _12272cb4 = () => interopDefault(import('../../../pages/settings/_section/index.vue' /* webpackChunkName: "pages/settings/_section/index" */))
const _1aecc0bb = () => interopDefault(import('../../../pages/sold-property/_id/index.vue' /* webpackChunkName: "pages/sold-property/_id/index" */))
const _6407c32a = () => interopDefault(import('../../../pages/user/_id/index.vue' /* webpackChunkName: "pages/user/_id/index" */))
const _52e54bcc = () => interopDefault(import('../../../pages/listings/_id/audit/index.vue' /* webpackChunkName: "pages/listings/_id/audit/index" */))
const _62dd4393 = () => interopDefault(import('../../../pages/listings/_id/dashboard/index.vue' /* webpackChunkName: "pages/listings/_id/dashboard/index" */))
const _8f8e06f6 = () => interopDefault(import('../../../pages/listings/_id/submit-success/index.vue' /* webpackChunkName: "pages/listings/_id/submit-success/index" */))
const _4b940c77 = () => interopDefault(import('../../../pages/listings/_id/viewings/_type/index.vue' /* webpackChunkName: "pages/listings/_id/viewings/_type/index" */))
const _7d4c7276 = () => interopDefault(import('../../../pages/users/_id/_section/index.vue' /* webpackChunkName: "pages/users/_id/_section/index" */))
const _a5b04f9e = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404-error",
    component: _1bf39195,
    name: "404-error"
  }, {
    path: "/app",
    component: _2ca16643,
    name: "app"
  }, {
    path: "/builder-data-reports",
    component: _63a74dc2,
    name: "builder-data-reports"
  }, {
    path: "/buy-sell-your-home",
    component: _04b87f59,
    name: "buy-sell-your-home"
  }, {
    path: "/buy-your-home",
    component: _6965fdd4,
    name: "buy-your-home"
  }, {
    path: "/calendar",
    component: _b475721c,
    name: "calendar"
  }, {
    path: "/commissions-calculator",
    component: _4b75d9bb,
    name: "commissions-calculator"
  }, {
    path: "/comparables",
    component: _4c3d41fb,
    name: "comparables"
  }, {
    path: "/contact",
    component: _13fd3bfc,
    name: "contact"
  }, {
    path: "/faq",
    component: _12a6ee10,
    name: "faq"
  }, {
    path: "/favourites",
    component: _1fa91144,
    name: "favourites"
  }, {
    path: "/homeowner-dashboard",
    component: _5569f2dd,
    name: "homeowner-dashboard"
  }, {
    path: "/list-home",
    component: _61c3e750,
    name: "list-home"
  }, {
    path: "/listing-management",
    component: _790043c0,
    name: "listing-management"
  }, {
    path: "/login",
    component: _72946bcb,
    name: "login"
  }, {
    path: "/market-data",
    component: _dd00b186,
    name: "market-data"
  }, {
    path: "/messages",
    component: _9be4d900,
    name: "messages"
  }, {
    path: "/my-abode-overview",
    component: _72944d0c,
    name: "my-abode-overview"
  }, {
    path: "/my-listings",
    component: _f566685c,
    name: "my-listings"
  }, {
    path: "/offer-management-buyer",
    component: _28522fee,
    name: "offer-management-buyer"
  }, {
    path: "/offer-management-seller",
    component: _5f85f4fa,
    name: "offer-management-seller"
  }, {
    path: "/offers",
    component: _29f4576a,
    name: "offers"
  }, {
    path: "/photo-booking-confirmation",
    component: _7aa4c450,
    name: "photo-booking-confirmation"
  }, {
    path: "/privacy",
    component: _c37d812c,
    name: "privacy"
  }, {
    path: "/pro-edit",
    component: _6fb655de,
    name: "pro-edit"
  }, {
    path: "/pro-marketplace",
    component: _4bf1af66,
    name: "pro-marketplace"
  }, {
    path: "/pro-search",
    component: _76db1488,
    name: "pro-search"
  }, {
    path: "/request-sticker",
    component: _58895c21,
    name: "request-sticker"
  }, {
    path: "/search",
    component: _1cf031c8,
    name: "search"
  }, {
    path: "/sell-your-home",
    component: _af56f31c,
    name: "sell-your-home"
  }, {
    path: "/signup",
    component: _1bbf668c,
    name: "signup"
  }, {
    path: "/sold-data",
    component: _c287ad36,
    name: "sold-data"
  }, {
    path: "/terms-of-service",
    component: _24edceb9,
    name: "terms-of-service"
  }, {
    path: "/users",
    component: _73728faa,
    name: "users"
  }, {
    path: "/whoweare",
    component: _62ccd2fc,
    name: "whoweare"
  }, {
    path: "/why-bode",
    component: _32ecb9e7,
    name: "why-bode"
  }, {
    path: "/admin/builder-report-management",
    component: _fb1ddb28,
    name: "admin-builder-report-management"
  }, {
    path: "/admin/conversation",
    component: _378ce177,
    name: "admin-conversation"
  }, {
    path: "/admin/offer-management",
    component: _ffdc90f0,
    name: "admin-offer-management"
  }, {
    path: "/admin/showings",
    component: _c8ac1dfc,
    name: "admin-showings"
  }, {
    path: "/listings/review",
    component: _184e52d2,
    name: "listings-review"
  }, {
    path: "/login/idp",
    component: _d869df1e,
    name: "login-idp"
  }, {
    path: "/login/reset",
    component: _52baea4b,
    name: "login-reset"
  }, {
    path: "/offers/submit-success",
    component: _6a6998e8,
    name: "offers-submit-success"
  }, {
    path: "/offers/summary",
    component: _c7d80fbc,
    name: "offers-summary"
  }, {
    path: "/pro-edit/profile",
    component: _b7fa9e10,
    name: "pro-edit-profile"
  }, {
    path: "/pro-edit/service",
    component: _07c80f04,
    name: "pro-edit-service"
  }, {
    path: "/pro-marketplace/marketplace-for-pros",
    component: _ecd0bd78,
    name: "pro-marketplace-marketplace-for-pros"
  }, {
    path: "/pro-marketplace/pro-login",
    component: _45ac6647,
    name: "pro-marketplace-pro-login"
  }, {
    path: "/pro-marketplace/pro-portal",
    component: _ff888c38,
    name: "pro-marketplace-pro-portal"
  }, {
    path: "/pro-marketplace/service-request",
    component: _13899496,
    name: "pro-marketplace-service-request"
  }, {
    path: "/pro-marketplace/service-requests",
    component: _45468f18,
    name: "pro-marketplace-service-requests"
  }, {
    path: "/search/saved-search-list",
    component: _c2a1132c,
    name: "search-saved-search-list"
  }, {
    path: "/signup/additional-information",
    component: _1b05ac82,
    name: "signup-additional-information"
  }, {
    path: "/signup/confirm",
    component: _029d5ffd,
    name: "signup-confirm"
  }, {
    path: "/admin/listings/import",
    component: _6d16e032,
    name: "admin-listings-import"
  }, {
    path: "/admin/listings/update",
    component: _1e4a380b,
    name: "admin-listings-update"
  }, {
    path: "/ds/callback/listing",
    component: _8b2e09c8,
    name: "ds-callback-listing"
  }, {
    path: "/ds/callback/offer",
    component: _2c8be834,
    name: "ds-callback-offer"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up",
    component: _e94c0a80,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up"
  }, {
    path: "/pro-marketplace/service-request/photography-measurements",
    component: _145b7052,
    name: "pro-marketplace-service-request-photography-measurements"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up/successful",
    component: _69bf4f1f,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up-successful"
  }, {
    path: "/pro-marketplace/profile/:id",
    component: _602033d2,
    name: "pro-marketplace-profile-id"
  }, {
    path: "/pro-marketplace/view-request/:id",
    component: _aacf97ac,
    name: "pro-marketplace-view-request-id"
  }, {
    path: "/buyer-checklist/:page",
    component: _453c84e6,
    name: "buyer-checklist-page"
  }, {
    path: "/how-it-works/:id",
    component: _69e9781c,
    name: "how-it-works-id"
  }, {
    path: "/listing-editing/:id",
    component: _651c61dc,
    name: "listing-editing-id"
  }, {
    path: "/listings/:id",
    component: _0ed14a4e,
    name: "listings-id"
  }, {
    path: "/pro/:id",
    component: _2f43fb3a,
    name: "pro-id"
  }, {
    path: "/seller-checklist/:page",
    component: _2b84c82b,
    name: "seller-checklist-page"
  }, {
    path: "/settings/:section",
    component: _12272cb4,
    name: "settings-section"
  }, {
    path: "/sold-property/:id",
    component: _1aecc0bb,
    name: "sold-property-id"
  }, {
    path: "/user/:id",
    component: _6407c32a,
    name: "user-id"
  }, {
    path: "/listings/:id?/audit",
    component: _52e54bcc,
    name: "listings-id-audit"
  }, {
    path: "/listings/:id?/dashboard",
    component: _62dd4393,
    name: "listings-id-dashboard"
  }, {
    path: "/listings/:id?/submit-success",
    component: _8f8e06f6,
    name: "listings-id-submit-success"
  }, {
    path: "/listings/:id?/viewings/:type",
    component: _4b940c77,
    name: "listings-id-viewings-type"
  }, {
    path: "/users/:id/:section",
    component: _7d4c7276,
    name: "users-id-section"
  }, {
    path: "/",
    component: _a5b04f9e,
    name: "index"
  }, {
    path: "/buyer-checklist",
    redirect: "/buyer-checklist/getting-ready",
    name: "/buyer-checklist"
  }, {
    path: "/how-it-works",
    redirect: "/how-it-works/seller",
    name: "/how-it-works"
  }, {
    path: "/howitworks",
    redirect: "/how-it-works/seller",
    name: "/howitworks"
  }, {
    path: "/listings",
    redirect: "/search",
    name: "/listings"
  }, {
    path: "/listings/:city/:community/:propertyType/:price/:id",
    redirect: "/listings/:id",
    name: "/listings/:city/:community/:propertyType/:price/:id"
  }, {
    path: "/logout",
    redirect: "/",
    name: "/logout"
  }, {
    path: "/error404",
    redirect: "/404-error",
    name: "/error404"
  }, {
    path: "/pro-:id-:companyname",
    redirect: "/pro/:id",
    name: "/pro-:id-:companyname"
  }, {
    path: "/profiles/:id",
    redirect: "/user/:id",
    name: "/profiles/:id"
  }, {
    path: "/seller-checklist",
    redirect: "/seller-checklist/getting-ready",
    name: "/seller-checklist"
  }, {
    path: "/start-listing",
    redirect: "/sell-your-home",
    name: "/start-listing"
  }, {
    path: "/terms",
    redirect: "/terms-of-service",
    name: "/terms"
  }, {
    path: "/whybode",
    redirect: "/why-bode",
    name: "/whybode"
  }, {
    path: "/who-we-are",
    redirect: "/whoweare",
    name: "/who-we-are"
  }, {
    path: "/offers/seller",
    redirect: "/offer-management-seller",
    name: "/offers/seller"
  }, {
    path: "/offers/buyer",
    redirect: "/offer-management-buyer",
    name: "/offers/buyer"
  }, {
    path: "/documents",
    redirect: "/offer-management-seller",
    name: "/documents"
  }, {
    path: "/list-your-home",
    redirect: "/list-home",
    name: "/list-your-home"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
